module.exports = __webpack_public_path__ + "img/toe-roman.db96e7b4.svg";